<!-- внешние страницы работы с операциями  -->
<template>

	<div v-if="!$store.state.is_auth && ($route.path.indexOf('/operation/select/') === 0 || $route.path.indexOf('/operation/pay/') === 0 || $route.path.indexOf('/operation/view/') === 0 || $route.path === '/operation/list')">

		<!-- топ меню -->
		<nav class="navbar navbar-default navbar-fixed-top" style="right: -15px;">
			<div class="container-fluid" style="padding-right: 30px;">
				<div class="navbar-header">
					<a :href="MainSite" class="navbar-brand w5-navbar-logo-link">
						<img :src="stylePathToLogo || '/static/img/logo/logo.png'" class="w5-navbar-logo-img visible-xs">
						<img :src="stylePathToLogoText || '/static/img/logo/logo-text.png'" class="w5-navbar-logo-img hidden-xs">
					</a>
				</div>				
			</div>
		</nav>

		<!-- основной блок страницы -->
		<div class="container-fluid">
			<div class="row">
				<div class="col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3">
					<router-view />
				</div>
			</div>
		</div>

	</div>

</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Vue from 'vue'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'operationPage',
	//=========================================================================
	// локальные переменные компонента
	//=========================================================================
	data: function() {
		return {
			// видимость топ меню
			topMenuVisible: false
		}
	},
	//=========================================================================
	// высичляемый переменные
	//=========================================================================
	computed: {
		//---------------------------------------------------------------------
		// текущая конфигурация
		//---------------------------------------------------------------------
		MainSite() {
			return Vue.AppServerUrl
		}
	},
	//=========================================================================
	// обработчик: компонент примонтирован в DOM
	//=========================================================================
	mounted() {
		document.addEventListener('click', this.documentClick)
		window.addEventListener('resize', this.documentClick)
	},
	//=========================================================================
	// обработчик: перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		document.removeEventListener('click', this.documentClick)
		window.removeEventListener('resize', this.documentClick)
	},
	//=========================================================================
	// локальные методы
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// включение/выключение левого меню
		//---------------------------------------------------------------------
		toggleSideMenu() {
			this.topMenuVisible = !this.topMenuVisible
		},
		//---------------------------------------------------------------------
		// обработчик клика по всему документу
		//---------------------------------------------------------------------
		documentClick(e) {
			this.topMenuVisible = false
		}

		//---------------------------------------------------------------------
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.navbar-header.pull-right.open {
	display: block;
}

.w5-navbar-link.linkified.open, .w5-navbar-link.last-right {
	margin-left: 20px !important;
}

.mobile-top-menu {
	display: inline-block;
	margin: 0;
	list-style: none;
	background-color: #f8f8f8;
    width: 100%;
    border-top: 1px solid #e7e7e7;
    padding: 5px 0 0 0;
}

@media (max-width: 767px) {
	.navbar-header.pull-right.open {
		display: none;
	}

	.w5-navbar-link.linkified.open {
		margin-left: 0 !important;
		padding-left: 15px !important;
		display: block;
		width: 100%;
	}
	.w5-navbar-link.linkified.open:hover {
		color: #555;
    	background-color: #e7e7e7;
	}
}
</style>



// WEBPACK FOOTER //
// operationPage.vue?22cd80e1